import MapperBase from './MapperBase.js';

class AggregatedResultsMapper extends MapperBase{
    constructor(silent, fallback, pitchMapper, hitMapper){
        if (typeof(fallback) === 'undefined'){
            fallback = [];
        }

        super(silent, fallback);

        if (!(pitchMapper instanceof MapperBase)){
            throw new TypeError('pitchMapper must be an instance inheriting from MapperBase');
        }

        if (!(hitMapper instanceof MapperBase)){
            throw new TypeError('hitMapper must be an instance inheriting from MapperBase');
        }

        this.pitchMapper = pitchMapper;

        this.hitMapper = hitMapper;
    }

    map(item){
        let pitchesMapped = [];
        let hitsMapped = [];
        try {
            if (item.hasOwnProperty('Pitch')){
                pitchesMapped = this.mapPitches(item.Pitch);
            }
        } catch (error) {
            this.handleMappingError(error, pitchesMapped, item, 'Pitch');
        }

        try {
            if (item.hasOwnProperty('Hit')){
                hitsMapped = this.mapHits(item.Hit);
            }
        } catch (error) {
            this.handleMappingError(error, hitsMapped, item, 'Hit');
        }

        return pitchesMapped.concat(hitsMapped);
    }

    mapPitches(pitches){
        return this.pitchMapper.map(pitches);
    }

    mapHits(hits){
        return this.hitMapper.map(hits);
    }
}

export default AggregatedResultsMapper;